enum ENV {
  PROD = "prod",
  GAMMA = "gamma",
  BETA = "beta",
  LOCAL = "localhost",
}

enum REGION {
  NA = "na",
  EU = "eu",
  FE = "fe",
}

export const isProd = (): boolean => window.location.host.includes(ENV.PROD);
export const isGamma = (): boolean => window.location.host.includes(ENV.GAMMA);
export const isBeta = (): boolean => window.location.host.includes(ENV.BETA);
export const isLocal = (): boolean => window.location.host.includes(ENV.LOCAL);

export const isRegionalUrl = (): boolean =>
  window.location.host.includes(`.${REGION.NA}.`) ||
  window.location.host.includes(`.${REGION.EU}.`) ||
  window.location.host.includes(`.${REGION.FE}.`);
export const getUserRegion = () => {
  if (window.location.host.includes(`.${REGION.NA}.`)) return "NA";
  if (window.location.host.includes(`.${REGION.EU}.`)) return "EU";
  if (window.location.host.includes(`.${REGION.FE}.`)) return "FE";
  return "NA";
};
